import Super from 'ember-simplepractice/components/shared/signature/client-signature';
import styles from './client-signature-styles.module.scss';

export default class SharedSignatureClientSignature extends Super {
  constructor() {
    super(...arguments);
    this.styles['signature-box'] += ' ' + styles['signature-box'];
  }
}
